<template>
	<div class="content background1" style="display: flex">
		<div class="tableBox9" v-if="!qrCodeShow">
			<div class="tableMes">
				<div class="table">
					<div class="table" style="overflow-x: scroll;">
					  <tree ref="theTreeKnow" :dataTree="treeData" @getDeviceMes="getDeviceMes" :exceptEq="1"></tree>
					</div>
				</div>
			</div>
		</div>
		<div class="right-showbtn" @click="showBtn">
			<div class="right-showbtn-qrcode-background">
				<i v-if="qrCodeShow" class="el-icon-arrow-right" style="margin-top: 32px; margin-left: -3px; color: #FFFFFF;"></i>
				<i v-if="!qrCodeShow" class="el-icon-arrow-left" style="margin-top: 32px; margin-left: -3px; color: #FFFFFF;"></i>
			</div>
		</div>
		<div class="tableBox10" :style="{'padding':width=='0px'?'60px 0px 0px 0px':'60px 0px 0px 350px '}">
			<div class="tableMes">
				<div class="table" style="padding: 0">
					<div class="treeMes" v-if="getTreeMes=='1'">
						<p class="title"><span class="spot">{{deviceDetailMes.name}}</span>{{$t('label_701')}}</p>
						<div class="chooseBox6" style="width: 1280px;">
							<div class="selectBox">
								<div>
									<div class="selectChoose" style="width: 1000px;">
										<div class="selectText" style="width: 7%;">
											<p>{{$t('label_348')}}</p>
										</div>
										<div class="select otherInput" style="width:550px;">
											<el-radio-group v-model="faultPhenomenon" @change="search({pageNum: 1,pageSize: pageSize,});">
												<div v-for="item in faultPhenomenonList" style="display: inline-flex;width: 130px;">
													<el-radio :label="item.val">{{item.val}}</el-radio>
												</div>
												<div style="display: inline-flex;width: 130px;">
													<el-radio :label="$t('label_380')">{{$t('label_380')}}
														<el-input style="width: 220px;" v-model="fault" :disabled="faultPhenomenon == $t('label_380')?false:true"></el-input>
													</el-radio>
												</div>
												<!-- <div style="margin-left: 10px;" @click="dialogFaultResult=false"><i class="el-icon-question"></i></div> -->
											</el-radio-group>
										</div>
									</div>
								</div>
							</div>
							<div class="buttonBox buttonBoxRight" style="margin-left: 120px;float: left;top: 130px;">
								<div>
									<div class="chooseButton sendButton" @click="search({pageNum: 1,pageSize:pageSize,})"><i class="el-icon-search"></i>{{$t('btn_2')}}</div>
								</div>
							</div>
						</div>
						<div class="spotMes2Box">
							<div class="buttonBox">
								<div class="chooseButton searchButton" style="margin-right: 5px;" @click="insert"><i class="el-icon-circle-plus-outline"></i>{{$t('btn_14')}}</div>
								<div class="chooseButton searchButton" style="margin-right: 5px;" @click="update"><i class="el-icon-edit-outline"></i>{{$t('btn_15')}}</div>
								<div class="chooseButton deleteButton" style="margin-right: 5px;" @click="unDeleteVisible = true"><i class="el-icon-delete"></i>{{$t('btn_16')}}</div>
								<div class="chooseButton searchButton" style="margin-right: 5px;" @click="look"><i class="el-icon-view"></i>{{$t('btn_38')}}</div>
                <div class="chooseButton searchButton" @click="exportExcel" v-if="$store.getters.getVersions == 4">
                  <i class="el-icon-download"></i>{{$t('btn_10')}}
                </div>
							</div>
							<div class="tableMin" style="height: 90%;">
								<el-table :empty-text="$t('label_357')" ref="singleTable" :data="tableDataTreeTime" highlight-current-row @current-change="handleCurrentChangeTreeTime"
								 border style="width: 100%;margin: 10px 0" :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}"
								 height="110%">
									<el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index" :index="getIndex" width="50">
									</el-table-column>
									<el-table-column prop="faultPhenomenon" :label="$t('label_348')" align="left" width="200">
										<template slot-scope="scope">
											{{scope.row.faultPhenomenon}}<br>
											{{scope.row.faultExplain}}
										</template>
									</el-table-column>
									<el-table-column prop="faultReason" :label="$t('label_389')" align="center" width="300px">
										<template slot-scope="scope">
											{{scope.row.faultReasonClassify}}<br>
											{{scope.row.faultReason}}
										</template>
									</el-table-column>
									<el-table-column prop="solution" :label="$t('label_398')" align="left">
										<template slot-scope="scope">
											{{scope.row.solution}}
										</template>
									</el-table-column>
									<el-table-column prop="precaution" :label="$t('label_401')" align="left">
										<template slot-scope="scope">
											<p>{{scope.row.precaution}}</p>
										</template>
									</el-table-column>
									<el-table-column prop="frequency" :label="$t('label_385')" align="center">
										<template slot-scope="scope">
											<p>{{scope.row.frequency}}</p>
										</template>
									</el-table-column>
								</el-table>
								<Page class="item" ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3" :currentspage="1"
								 @parentMethod="search"></Page>
							</div>
						</div>
					</div>

				</div>
			</div>
		</div>

		<el-dialog v-loading="saveLoading" :title="$t('btn_14')" :visible.sync="unInsertVisible" append-to-body :close-on-click-modal='false'
		 width="1000px" top="6%" :before-close="handleClose" custom-class="dialogBox">
			<div class="dialogBoxMes" style="padding:0 20px;">
				<div class="dialogMes">
					<div class="dialogMes">
						<p><span style="color: #ff0000">*</span>{{$t('label_348')}}</p>
						<div class="mesInput" style="width: 500px;">
							<el-radio-group v-model="knowledgeList.faultPhenomenon">
								<div v-for="item in faultPhenomenonList" style="display: inline-flex;width: 130px;">
									<el-radio :label="item.val">{{item.val}}</el-radio>
								</div>
								<div style="display: inline-flex;width: 130px;">
									<el-radio :label="$t('label_380')">{{$t('label_380')}}
										<el-input class="otherInput" v-model="knowledgeList.fault" :disabled="knowledgeList.faultPhenomenon == $t('label_380')?false:true"></el-input>
									</el-radio>
								</div>
								<!-- <div style="margin-left: 10px;" @click="dialogFaultResult=false"><i class="el-icon-question"></i></div> -->
							</el-radio-group>
						</div>
					</div>
					<!-- <div class="dialogMes" style="margin-left: 100px">
						<p><span style="color: #ff0000">*</span>设备类型</p>
						<div class="mesInput">
							<el-select v-model="tableDataEdit.method" filterable ::placeholder="$t('input_65')">
								<el-option v-for="item in checkList" :key="item.key" :label="item.val" :value="item.key">
								</el-option>
							</el-select>
						</div>
					</div> -->
				</div>
				<div class="dialogMes">
					<p>{{$t('label_429')}}</p>
					<div class="mesInput" style="width: 680px">
						<el-autocomplete style="width:100%" v-model="knowledgeList.typeName"
							:fetch-suggestions="querySearchAsync" :placeholder="$t('input_55')" :trigger-on-focus="false"
							@select="handleSelect4" clearable value-key="name"><i slot="suffix" class="el-input__icon el-icon-search"></i>
						</el-autocomplete>
					</div>
				</div>
				<div class="dialogMes">
					<p>{{$t('label_382')}}</p>
					<div class="mesInput" style="width: 680px">
						<el-input type="textarea" :placeholder="$t('input_46')" v-model="knowledgeList.faultExplain"></el-input>
					</div>
				</div>
				<div class="dialogMes">
					<p><span style="color: #ff0000">*</span>{{$t('label_389')}}</p>
					<div class="mesInput" style="width: 680px">
						<el-select v-model="knowledgeList.faultReasonClassify" @change="getNameList2" filterable :placeholder="$t('input_65')">
							<el-option v-for="item in faultReasonClassifyList" :key="item.id" :label="$t(item.name)" :value="item.name">
							</el-option>
						</el-select>
						<el-select v-model="knowledgeList.faultReason" filterable :placeholder="$t('input_65')">
							<el-option v-for="item in faultReasonList" :key="item.val" :label="item.val" :value="item.val">
							</el-option>
						</el-select>
					</div>
				</div>
				<div class="dialogMes">
					<div class="dialogMes">
						<p>{{$t('label_648')}}</p>
						<div class="selectMes" style="width: 320px;border:1px solid #dedede;height: 320px;overflow:auto;">
							<div class="mesInput" style="width: 100%;">
								<el-input type="textarea" :placeholder="$t('input_46')" rows="8" v-model="knowledgeList.solution"></el-input>
							</div>
							<p>{{$t('label_650')}}</p>
							<el-checkbox-group v-model="knowledgeList.checkList3" @change="setMealSelect" style="margin-left: 10px;">
							    <el-checkbox label="0">{{$t('label_838')}}</el-checkbox>
							    <el-checkbox label="1">{{$t('label_839')}}</el-checkbox>
							</el-checkbox-group>
							<el-checkbox-group v-model="knowledgeList.checkList1" style="margin-left: 10px;">
								<el-checkbox v-for="check in checkList2" :label="check.key" :key="check.key" :disabled="knowledgeList.checkList3[0]=='0'?false:true">{{check.val}}</el-checkbox>
							</el-checkbox-group>
							<el-checkbox :label="$t('label_380')" v-model="knowledgeList.other" style="margin-left: 10px;" :disabled="knowledgeList.checkList3[0]=='0'?false:true">{{$t('label_380')}}
								<el-input class="otherInput" v-model="knowledgeList.otherInput" :disabled="knowledgeList.other?false:true"></el-input>
							</el-checkbox>

						</div>
					</div>
					<div class="dialogMes" style="margin-left: 40px">
						<p>{{$t('label_401')}}</p>
						<div class="selectMes" style="width: 320px;border:1px solid #dedede;height: 319px;overflow:auto;">
							<div style="margin: 17px 10px;">
								<el-checkbox-group v-model="knowledgeList.checkList2">
									<el-checkbox v-for="check in checkList3" :label="check.key" :key="check.key">{{check.val}}</el-checkbox>
								</el-checkbox-group>
								<el-checkbox :label="$t('label_380')" v-model="knowledgeList.other1">{{$t('label_380')}}
									<el-input class="otherInput" v-model="knowledgeList.otherInput1" :disabled="knowledgeList.other1?false:true"></el-input>
								</el-checkbox>
							</div>
							<div class="mesInput" style="width: 100%;">
								<el-input type="textarea" :placeholder="$t('input_46')" rows="12" v-model="knowledgeList.precaution"></el-input>
							</div>
						</div>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<div class="chooseButton sendButton" @click="unInsertSend">{{$t('btn_13')}}</div>
			</span>
		</el-dialog>

		<el-dialog v-loading="saveLoading" :title="$t('btn_15')" :visible.sync="unUpdateVisible" append-to-body :close-on-click-modal='false'
		 width="1000px" top="6%" :before-close="handleClose" custom-class="dialogBox">
			<div class="dialogBoxMes" style="padding:0 20px;">
				<div class="dialogMes">
					<div class="dialogMes">
						<p><span style="color: #ff0000">*</span>{{$t('label_348')}}</p>
						<div class="mesInput" style="width: 500px;">
							<el-radio-group v-model="knowledgeList.faultPhenomenon">
								<div v-for="item in faultPhenomenonList" style="display: inline-flex;width: 100px;">
									<el-radio :label="item.val">{{item.val}}</el-radio>
								</div>
								<div style="display: inline-flex;width: 100px;">
									<el-radio :label="$t('label_380')">{{$t('label_380')}}
										<el-input class="otherInput" v-model="knowledgeList.fault" :disabled="knowledgeList.faultPhenomenon == $t('label_380')?false:true"></el-input>
									</el-radio>
								</div>
								<!-- <div style="margin-left: 10px;" @click="dialogFaultResult=false"><i class="el-icon-question"></i></div> -->
							</el-radio-group>
						</div>
					</div>
					<!-- <div class="dialogMes" style="margin-left: 100px">
						<p><span style="color: #ff0000">*</span>设备类型</p>
						<div class="mesInput">
							<el-select v-model="tableDataEdit.method" filterable ::placeholder="$t('input_65')">
								<el-option v-for="item in checkList" :key="item.key" :label="item.val" :value="item.key">
								</el-option>
							</el-select>
						</div>
					</div> -->
				</div>
				<div class="dialogMes">
					<p>{{$t('label_429')}}</p>
					<div class="mesInput" style="width: 680px">
						<el-autocomplete style="width:100%" v-model="knowledgeList.typeName"
							:fetch-suggestions="querySearchAsync" :placeholder="$t('input_55')" :trigger-on-focus="false"
							@select="handleSelect4" value-key="name"><i slot="suffix" class="el-input__icon el-icon-search"></i>
						</el-autocomplete>
					</div>
				</div>
				<div class="dialogMes">
					<p>{{$t('label_382')}}</p>
					<div class="mesInput" style="width: 680px">
						<el-input type="textarea" :placeholder="$t('input_46')" v-model="knowledgeList.faultExplain"></el-input>
					</div>
				</div>
				<div class="dialogMes">
					<p><span style="color: #ff0000">*</span>{{$t('label_389')}}</p>
					<div class="mesInput" style="width: 680px">
						<el-select v-model="knowledgeList.faultReasonClassify" @change="getNameList2" filterable :placeholder="$t('input_65')">
							<el-option v-for="item in faultReasonClassifyList" :key="item.id" :label="$t(item.name)" :value="item.name">
							</el-option>
						</el-select>
						<el-select v-model="knowledgeList.faultReason" filterable :placeholder="$t('input_65')">
							<el-option v-for="item in faultReasonList" :key="item.val" :label="item.val" :value="item.val">
							</el-option>
						</el-select>
					</div>
				</div>
				<div class="dialogMes">
					<div class="dialogMes">
						<p>{{$t('label_648')}}</p>
						<div class="selectMes" style="width: 320px;border:1px solid #dedede;height: 320px;overflow:auto;">
							<div class="mesInput" style="width: 100%;">
								<el-input type="textarea" :placeholder="$t('input_46')" rows="8" v-model="knowledgeList.solution"></el-input>
							</div>
							<p>{{$t('label_650')}}</p>
							<el-checkbox-group v-model="knowledgeList.checkList3" @change="setMealSelect" style="margin-left: 10px;">
							    <el-checkbox label="0">{{$t('label_838')}}</el-checkbox>
							    <el-checkbox label="1">{{$t('label_839')}}</el-checkbox>
							</el-checkbox-group>
							<el-checkbox-group v-model="knowledgeList.checkList1" style="margin-left: 10px;">
								<el-checkbox v-for="check in checkList2" :label="check.key" :key="check.key" :disabled="knowledgeList.checkList3[0]=='0'?false:true">{{check.val}}</el-checkbox>
							</el-checkbox-group>
							<el-checkbox :label="$t('label_380')" v-model="knowledgeList.other" style="margin-left: 10px;" :disabled="knowledgeList.checkList3[0]=='0'?false:true">{{$t('label_380')}}
								<el-input class="otherInput" v-model="knowledgeList.otherInput" :disabled="knowledgeList.other?false:true"></el-input>
							</el-checkbox>

						</div>
					</div>
					<div class="dialogMes" style="margin-left: 40px">
						<p>{{$t('label_401')}}</p>
						<div class="selectMes" style="width: 320px;border:1px solid #dedede;height: 319px;overflow:auto;">
							<div style="margin: 17px 10px;">
								<el-checkbox-group v-model="knowledgeList.checkList2">
									<el-checkbox v-for="check in checkList3" :label="check.key" :key="check.key">{{check.val}}</el-checkbox>
								</el-checkbox-group>
								<el-checkbox :label="$t('label_380')" v-model="knowledgeList.other1">{{$t('label_380')}}
									<el-input class="otherInput" v-model="knowledgeList.otherInput1" :disabled="knowledgeList.other1?false:true"></el-input>
								</el-checkbox>
							</div>
							<div class="mesInput" style="width: 100%;">
								<el-input type="textarea" :placeholder="$t('input_46')" rows="12" v-model="knowledgeList.precaution"></el-input>
							</div>
						</div>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<div class="chooseButton sendButton" @click="unUpdateSend">{{$t('btn_13')}}</div>
			</span>
		</el-dialog>

		<el-dialog
		  :title="$t('btn_16')"
		  :visible.sync="unDeleteVisible" append-to-body
		  :close-on-click-modal = 'false'
		  width="30%"
		  top="10%"
		  center
		  :before-close="handleClose" custom-class="dialogBox">
		  <p style="text-align: center;font-size: 16px">{{$t('msg_66')}}?</p>
		  <div class="btnBox2" style="width: 100%;justify-content: center;">
			  <div class="editButton" @click="unDeleteVisible = false" style="">{{$t('btn_1')}}</div>
			  <div class="delButton" @click="unDeleteSend"><i class="el-icon-delete-solid"></i>{{$t('btn_16')}}</div>
			</div>
		</el-dialog>
		<el-dialog :title="$t('btn_38')" :visible.sync="unLookVisible" append-to-body :close-on-click-modal='false'
		 width="1000px" top="6%" :before-close="handleClose" custom-class="dialogBox">
			<div class="dialogBoxMes" style="padding:0 20px;">
				<div class="dialogMes">
					<div class="dialogMes">
						<p><span style="color: #ff0000">*</span>{{$t('label_348')}}</p>
						<div class="mesInput" style="width: 500px;">
							<el-radio-group v-model="knowledgeList.faultPhenomenon">
								<div v-for="item in faultPhenomenonList" style="display: inline-flex;width: 100px;">
									<el-radio :label="item.val" disabled="true">{{item.val}}</el-radio>
								</div>
								<div style="display: inline-flex;width: 100px;">
									<el-radio :label="$t('label_380')" disabled="true">{{$t('label_380')}}
										<el-input class="otherInput" v-model="knowledgeList.fault" disabled="true"></el-input>
									</el-radio>
								</div>
								<!-- <div style="margin-left: 10px;" @click="dialogFaultResult=false"><i class="el-icon-question"></i></div> -->
							</el-radio-group>
						</div>
					</div>
					<!-- <div class="dialogMes" style="margin-left: 100px">
						<p><span style="color: #ff0000">*</span>设备类型</p>
						<div class="mesInput">
							<el-select v-model="tableDataEdit.method" filterable ::placeholder="$t('input_65')">
								<el-option v-for="item in checkList" :key="item.key" :label="item.val" :value="item.key">
								</el-option>
							</el-select>
						</div>
					</div> -->
				</div>
				<div class="dialogMes">
					<p>{{$t('label_429')}}</p>
					<div class="mesInput" style="width: 680px">
						<el-autocomplete style="width:100%" v-model="knowledgeList.typeName"
							:fetch-suggestions="querySearchAsync" :placeholder="$t('input_55')" :trigger-on-focus="false"
							@select="handleSelect4" value-key="name" disabled="true"><i slot="suffix" class="el-input__icon el-icon-search"></i>
						</el-autocomplete>
					</div>
				</div>
				<div class="dialogMes">
					<p>{{$t('label_382')}}</p>
					<div class="mesInput" style="width: 680px">
						<el-input type="textarea" :placeholder="$t('input_46')" v-model="knowledgeList.faultExplain" disabled="true"></el-input>
					</div>
				</div>
				<div class="dialogMes">
					<p><span style="color: #ff0000">*</span>{{$t('label_389')}}</p>
					<div class="mesInput" style="width: 680px">
						<el-select v-model="knowledgeList.faultReasonClassify" filterable :placeholder="$t('input_65')" disabled="true">
							<el-option v-for="item in faultReasonClassifyList" :key="item.id" :label="$t(item.name)" :value="item.name">
							</el-option>
						</el-select>
						<el-select v-model="knowledgeList.faultReason" filterable :placeholder="$t('input_65')" disabled="true">
							<el-option v-for="item in faultReasonList" :key="item.val" :label="item.val" :value="item.val">
							</el-option>
						</el-select>
					</div>
				</div>
				<div class="dialogMes">
					<!-- <div class="dialogMes">
						<p>维修过程</p>
						<div class="selectMes" style="width: 320px;border:1px solid #dedede;height: 320px;overflow:auto;">
							<p>对环境影响</p>
							<el-checkbox-group v-model="knowledgeList.checkList3" @change="setMealSelect" style="margin-left: 10px;">
							    <el-checkbox label="0">有</el-checkbox>
							    <el-checkbox label="1">无</el-checkbox>
							</el-checkbox-group>
							<el-checkbox-group v-model="knowledgeList.checkList1" style="margin-left: 10px;">
								<el-checkbox v-for="check in checkList2" :label="check.key" :key="check.key">{{check.val}}</el-checkbox>
							</el-checkbox-group>
							<el-checkbox :label="$t('label_380')" v-model="knowledgeList.other" style="margin-left: 10px;">{{$t('label_380')}}
								<el-input class="otherInput" v-model="knowledgeList.otherInput" :disabled="knowledgeList.other?false:true"></el-input>
							</el-checkbox>
							<div class="mesInput" style="width: 100%;">
								<el-input type="textarea" :placeholder="请输入内容" rows="8" v-model="knowledgeList.solution"></el-input>
							</div>
						</div>
					</div> -->
					<div class="dialogMes">
						<p>{{$t('label_648')}}</p>
						<div class="selectMes" style="width: 320px;border:1px solid #dedede;height: 320px;overflow:auto;">
							<div class="mesInput" style="width: 100%;">
								<el-input type="textarea" :placeholder="$t('input_46')" rows="8" v-model="knowledgeList.solution" disabled="true"></el-input>
							</div>
							<p>{{$t('label_650')}}</p>
							<el-checkbox-group v-model="knowledgeList.checkList3" @change="setMealSelect" style="margin-left: 10px;" disabled="true">
							    <el-checkbox label="0">{{$t('label_838')}}</el-checkbox>
							    <el-checkbox label="1">{{$t('label_839')}}</el-checkbox>
							</el-checkbox-group>
							<el-checkbox-group v-model="knowledgeList.checkList1" style="margin-left: 10px;">
								<el-checkbox v-for="check in checkList2" :label="check.key" :key="check.key" disabled="true">{{check.val}}</el-checkbox>
							</el-checkbox-group>
							<el-checkbox :label="$t('label_380')" v-model="knowledgeList.other" style="margin-left: 10px;" :disabled="knowledgeList.checkList3[0]=='0'?false:true">{{$t('label_380')}}
								<el-input class="otherInput" v-model="knowledgeList.otherInput" disabled="true"></el-input>
							</el-checkbox>

						</div>
					</div>
					<div class="dialogMes" style="margin-left: 40px">
						<p>{{$t('label_401')}}</p>
						<div class="selectMes" style="width: 320px;border:1px solid #dedede;height: 319px;overflow:auto;">
							<div style="margin: 17px 10px;">
								<el-checkbox-group v-model="knowledgeList.checkList2">
									<el-checkbox v-for="check in checkList3" :label="check.key" :key="check.key" disabled="true">{{check.val}}</el-checkbox>
								</el-checkbox-group>
								<el-checkbox :label="$t('label_380')" v-model="knowledgeList.other1" disabled="true">{{$t('label_380')}}
									<el-input class="otherInput" v-model="knowledgeList.otherInput1" disabled="true"></el-input>
								</el-checkbox>
							</div>
							<div class="mesInput" style="width: 100%;">
								<el-input type="textarea" :placeholder="$t('input_46')" rows="12" v-model="knowledgeList.precaution" disabled="true"></el-input>
							</div>
						</div>
					</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import "@/assets/css/map/map.css"
	import "@/assets/css/common/spot.css"
	import Page from "@/components/common/page";
	import TimePage from "@/assets/js/timePage/timePage.js";
	import utils from '@/utils/utils'
	import tree from "@/components/list/tree/malfunctionTree";
	import maintenance from "@/assets/js/maintenance/maintenance.js";
	import malfunction from "@/assets/js/malfunction/malfunction.js";
	import knowledge from "@/assets/js/knowledge/knowledge.js";
	import exportMes from "@/components/list/export/export";
	import file from "@/assets/js/file/file.js";
	export default {
		name: 'spotResumePage',
		components: {
			Page,
			tree,
			exportMes,
		},
		data() {
			return {
        saveLoading: false,
				pageNum: 1,
				pageSize: 10,
				pageCount: 0,
				getTreeMes: '1',
				dialogFaultResult: false,
				dialogSpotResult: false,
				dialogSpotTimeEdit: false,
				dialogSpotBatchTimeEdit: false,
				unInsertVisible: false,
				unUpdateVisible: false,
				unDeleteVisible: false,
				unLookVisible: false,
				fengXianConfrim: [],
				tableDataTree: [],
				checkList1: [],
				checkList2: [],
				checkList3: [],
				treeData: {
					dataDevice: [],
					searchShow: true,
					statusShow: true,
					statusListShow: true,
					cardShow: true,
					dataAll: true,
					funtoGetMes: '2'
				},
				treeData2: {
					dataDevice: [],
					searchShow: true,
					statusShow: true,
					statusListShow: true,
					cardShow: true,
					dataAll: true,
					funtoGetMes: '3'
				},
				tableDataTreeTime: [],
				deviceDetailMes: {},
				tableDataTreeInfo: [],
				faultLevel: '',
				faultPhenomenon: '',
				faultReasonList: [],
				faultReasonClassifyList: [],
				faultPhenomenonList: [],
				tableInfo: [],
				fault: '',
				type: '',
				faultReason: '',
				faultReasonClassify: '',
				equipmentTypeId: '',
				id:'',
				knowledgeList: {
					id: '',
					faultPhenomenon: '',
					faultExplain: '',
					faultReason: '',
					solution: '',
					precaution: '',
					frequency: '',
					equipmentTypeId: '',
					faultReasonClassify: '',
					checkList1: [],
					checkList2: [],
					checkList3: [],
					other: '',
					otherInput: '',
					other1: '',
					otherInput1: '',
					impact: '',
					impactKey: '',
					impactVal: '',
					precautionKey: '',
					precautionVal: '',
					fault: '',
					typeName: '',
				},
				width: '340px',
				qrCodeShow: false,
			}
		},
		methods: {
			getIndex(index) {
				return (this.pageNum - 1) * this.pageSize + index + 1
			},
			handleClose() {
				this.unInsertVisible = false;
				this.unUpdateVisible = false;
				this.unDeleteVisible = false;
				this.unLookVisible = false;
			},
			handleCurrentChangeAll(info) {},
			handleCurrentChangeDevice(info) {},
			handleCurrentChangeTree(info) {
				this.tableDataTreeInfo = info;
			},
			tableDataTreeInfoEdit() {
				if (Object.keys(this.tableDataTreeInfo).length > 0) {
					this.dialogDeviceSpot = true;
					this.tableDataTreeEdit = this.tableDataTreeInfo;
				} else {
					utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
				}
			},
			handleCurrentChangeTreeTime(info) {
				this.tableInfo = info;
			},
			handleNodeClickDevice(data) {
				if (data.label == this.$t('label_272')) {
					this.getTreeMes = '1';
				} else {
					this.getTreeMes = '1';
				}
			},
			handleNodeClickArea(data) {
				if (data.label == this.$t('label_272')) {
					this.getTreeMes = '1';
				} else {
					this.getTreeMes = '1';
				}
			},
			handleClickTree(tab, event) {
				this.getTreeMes = '1';
				this.deviceDetailMes = {};
				this.search({
					pageNum: 1,
					pageSize: this.pageSize,
				});
			},
			handleClickSpot(tab, event) {
				// console.log(tab, event);
			},
			handleClickDevice(tab, event) {
				// console.log(tab, event);
			},
			search(param) {
				this.tableDataTreeTime = [];
				let fault = "";
				if (this.faultPhenomenon == this.$t('label_380')) {
					fault = this.fault;
				} else {
					fault = this.faultPhenomenon;
				}
				var dataParam = {
					faultPhenomenon: fault,
					type: this.type,
					id: this.id,
					equipmentTypeId: this.equipmentTypeId,
					faultReason: this.faultReason,
					faultReasonClassify: this.faultReasonClassify
				}
				var newParam = Object.assign(param, dataParam);
				this.pageNum = newParam.pageNum;
				this.pageSize = newParam.pageSize;
				this.searchPage(newParam);
			},
			searchPage(param) {
				knowledge.getPage(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.tableDataTreeTime = data.data.records
						this.pageSize = data.data.size;
						this.pageCount = data.data.total;
						this.pageNum = data.data.current;
						this.$refs['pageModel'].setCurrent(this.pageNum);
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			getDeviceMes(data) {
				if (data.name == this.$t('label_272')) {
					this.type = 2;
					this.deviceDetailMes = {};
					this.search({
						pageNum: 1,
						pageSize: this.pageSize,
					});
				} else {
					this.deviceDetailMes = data;
					this.type = data.type;
					if (data.type == 1) {
						this.id = data.equipmentTypeId;
					} else {
						this.id = data.id;
					}
					this.faultReason = data.faultReason;
					this.faultReasonClassify = data.faultReasonClassify;
					this.search({
						pageNum: 1,
						pageSize: this.pageSize,
					});
				}
			},
			getDictList1() {
				file.getDictList1(9).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.faultReasonClassifyList = data.data;
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			getNameList2(param) {
				file.getDictList2({name: param, languageType: sessionStorage.getItem("languageType")}).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.faultReasonList = data.data;
						this.knowledgeList.faultReason = this.faultReasonList[0].val;
					}
				}).catch((response) => {
					console.log(response)
				})
        // file.getDictList2(param).then((response) => {
        //   const data = response.data;
        //   if (data.code == "1") {
        //     this.faultReasonList = data.data;
        //     this.knowledgeList.faultReason = this.faultReasonList[0].val;
        //   }
        // }).catch((response) => {
        //   console.log(response)
        // })
			},
      getNameListEdit2(param) {
        file.getDictList2({name: param, languageType: sessionStorage.getItem("languageType")}).then((response) => {
          const data = response.data;
          if (data.code == "1") {
            this.faultReasonList = data.data;
          }
        }).catch((response) => {
          console.log(response)
        })
        // file.getDictList2(param).then((response) => {
        //   const data = response.data;
        //   if (data.code == "1") {
        //     this.faultReasonList = data.data;
        //   }
        // }).catch((response) => {
        //   console.log(response)
        // })
      },
			getDictList2() {
        file.getByDictIdALL({dictId: 10, languageType: sessionStorage.getItem("languageType")}).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.faultReasonList = data.data;
					}
				}).catch((response) => {
					console.log(response)
				})
        // file.getDictList(10).then((response) => {
        //   const data = response.data;
        //   if (data.code == "1") {
        //     this.faultReasonList = data.data;
        //   }
        // }).catch((response) => {
        //   console.log(response)
        // })
			},
			getDictList3() {
        file.getByDictIdALL({dictId: 11, languageType: sessionStorage.getItem("languageType")}).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.faultPhenomenonList = data.data;
					}
				}).catch((response) => {
					console.log(response)
				})
        // file.getDictList(11).then((response) => {
        //   const data = response.data;
        //   if (data.code == "1") {
        //     this.faultPhenomenonList = data.data;
        //   }
        // }).catch((response) => {
        //   console.log(response)
        // })
			},
			getDictList4() {
        file.getByDictIdALL({dictId: 13, languageType: sessionStorage.getItem("languageType")}).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.checkList2 = data.data;
					}
				}).catch((response) => {
					console.log(response)
				})
        // file.getDictList(13).then((response) => {
        //   const data = response.data;
        //   if (data.code == "1") {
        //     this.checkList2 = data.data;
        //   }
        // }).catch((response) => {
        //   console.log(response)
        // })
			},
			getDictList5() {
        file.getByDictIdALL({dictId: 14, languageType: sessionStorage.getItem("languageType")}).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.checkList3 = data.data;
					}
				}).catch((response) => {
					console.log(response)
				})
        // file.getDictList(14).then((response) => {
        //   const data = response.data;
        //   if (data.code == "1") {
        //     this.checkList3 = data.data;
        //   }
        // }).catch((response) => {
        //   console.log(response)
        // })
			},
			insert() {
				this.knowledgeList.faultPhenomenon = '';
				this.knowledgeList.fault = '';
				this.knowledgeList.faultExplain = '';
				this.knowledgeList.faultReasonClassify = '';
				this.knowledgeList.faultReason = '';
				this.knowledgeList.checkList3 = [];
				this.knowledgeList.checkList1 = [];
				this.knowledgeList.other = '';
				this.knowledgeList.otherInput = '';
				this.knowledgeList.other1 = '';
				this.knowledgeList.otherInput1 = '';
				this.knowledgeList.solution = '';
				this.knowledgeList.checkList2 = [];
				this.knowledgeList.impactKey = '';
				this.knowledgeList.impactVal = '';
				this.knowledgeList.precautionKey = '';
				this.knowledgeList.precautionVal = '';
				this.knowledgeList.precaution = '';
				this.knowledgeList.typeName = '';
				this.unInsertVisible = true;
			},
			unInsertSend() {
        this.saveLoading = true;
				if (this.knowledgeList.faultPhenomenon == this.$t('label_380')) {
					this.knowledgeList.faultPhenomenon = this.knowledgeList.fault;
				}
				this.knowledgeList.impact = this.knowledgeList.checkList3[0];
				for(var key in this.knowledgeList.checkList1) {
					this.knowledgeList.impactKey += this.checkList2[key].key + ",";
					this.knowledgeList.impactVal += this.checkList2[key].val + ",";
				}
				if (this.knowledgeList.other) {
					this.knowledgeList.impactKey += "0";
					this.knowledgeList.impactVal += this.knowledgeList.otherInput;
				} else {
					this.knowledgeList.impactKey = this.knowledgeList.impactKey.substring(0,this.knowledgeList.impactKey.length - 1);
					this.knowledgeList.impactVal = this.knowledgeList.impactVal.substring(0,this.knowledgeList.impactVal.length - 1);
				}
				for(var key in this.knowledgeList.checkList2) {
					this.knowledgeList.precautionKey += this.checkList3[key].key + ",";
					this.knowledgeList.precautionVal += this.checkList3[key].val + ",";
				}
				if (this.knowledgeList.other1) {
					this.knowledgeList.precautionKey += "0";
					this.knowledgeList.precautionVal += this.knowledgeList.otherInput1;
				} else {
					this.knowledgeList.precautionKey = this.knowledgeList.precautionKey.substring(0,this.knowledgeList.precautionKey.length - 1);
					this.knowledgeList.precautionVal = this.knowledgeList.precautionVal.substring(0,this.knowledgeList.precautionVal.length - 1);
				}
				if (this.knowledgeList.faultPhenomenon == '' || this.knowledgeList.faultPhenomenon == null) {
					this.$message({
						message: this.$t('input_67'),
						type: 'error'
					});
          this.saveLoading = false;
					return;
				}
				if (this.knowledgeList.faultReasonClassify == '' || this.knowledgeList.faultReason == '') {
					this.$message({
						message: this.$t('input_68'),
						type: 'error'
					});
          this.saveLoading = false;
					return;
				}
				knowledge.insert(this.knowledgeList).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.unInsertVisible = false;
						this.$refs.theTreeKnow.reload();
						this.search({
							pageNum: this.pageNum,
							pageSize: this.pageSize,
						});
					}
          this.saveLoading = false;
				}).catch((response) => {
					console.log(response)
          this.saveLoading = false;
				})
			},
			update(){
				if (this.tableInfo != undefined && Object.keys(this.tableInfo).length > 0) {
					this.unUpdateVisible = true;
					this.knowledgeList.id = this.tableInfo.id;
					this.knowledgeList.equipmentTypeId = this.tableInfo.equipmentTypeId;
					this.knowledgeList.typeName = this.tableInfo.typeName;
					this.knowledgeList.faultPhenomenon = this.tableInfo.faultPhenomenon;
					let flag = true;
					for(var key in this.faultPhenomenonList) {
						if (this.faultPhenomenonList[key].val == this.knowledgeList.faultPhenomenon) {
							flag = false;
							break;
						}
					}
					if (flag) {
						this.knowledgeList.fault = this.knowledgeList.faultPhenomenon;
						this.knowledgeList.faultPhenomenon = this.$t('label_380');
					}
					this.knowledgeList.faultExplain = this.tableInfo.faultExplain;
					this.knowledgeList.faultReasonClassify = this.tableInfo.faultReasonClassify;
					this.getNameListEdit2(this.knowledgeList.faultReasonClassify);
					this.knowledgeList.faultReason = this.tableInfo.faultReason;
					if (this.tableInfo.impact != null) {
						this.knowledgeList.checkList3 = [];
						this.knowledgeList.checkList3.push(this.tableInfo.impact.toString());
					}
					this.knowledgeList.impact = this.knowledgeList.checkList3[0];
					this.knowledgeList.solution = this.tableInfo.solution;
					this.knowledgeList.precaution = this.tableInfo.precaution;
					if (this.tableInfo.impactKey != null) {
						this.knowledgeList.checkList1 = this.tableInfo.impactKey.split(",");
					}
					this.knowledgeList.frequency = this.tableInfo.frequency;
					let impactVal = "";
					if (this.tableInfo.impactVal != null&&this.tableInfo.impactVal != "") {
						impactVal = this.tableInfo.impactVal.split(",");
					}
					for(var key in this.knowledgeList.checkList1) {
						if (this.knowledgeList.checkList1[key] == 0) {
							this.knowledgeList.other = true;
							this.knowledgeList.otherInput = impactVal[impactVal.length - 1];
						}
					}
					if (this.tableInfo.precautionVal != null&&this.tableInfo.precautionVal != "") {
						let precautionVal = this.tableInfo.precautionVal.split(",");
						this.knowledgeList.checkList2 = this.tableInfo.precautionKey.split(",");
						for(var key in this.knowledgeList.checkList2) {
							if (this.knowledgeList.checkList2[key] == 0) {
								this.knowledgeList.other1 = true;
								this.knowledgeList.otherInput1 = precautionVal[precautionVal.length - 1];
							}
						}
					}
					this.knowledgeList.impactKey = this.tableInfo.impactKey;
					this.knowledgeList.impactVal = this.tableInfo.impactVal;
					this.knowledgeList.precautionKey = this.tableInfo.precautionKey;
					this.knowledgeList.precautionVal = this.tableInfo.precautionVal;
					if (this.knowledgeList.checkList3[0] == '1') {
						this.knowledgeList.checkList1 = [];
						this.knowledgeList.other = "";
						this.knowledgeList.otherInput = "";
					}
				} else {
						utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
				}
			},
			unUpdateSend() {
        this.saveLoading = true;
				if (this.knowledgeList.faultPhenomenon == '' || this.knowledgeList.faultPhenomenon == null) {
					this.$message({
						message: this.$t('input_67'),
						type: 'error'
					});
          this.saveLoading = false;
					return;
				}
				if (this.knowledgeList.faultReasonClassify == '' || this.knowledgeList.faultReason == '') {
					this.$message({
						message: this.$t('input_68'),
						type: 'error'
					});
          this.saveLoading = false;
					return;
				}
				if(this.knowledgeList.other1){
					if(this.knowledgeList.otherInput1==""||this.knowledgeList.otherInput1==null){
						this.$message({
							message: this.$t('msg_221'),
							type: 'error'
						});
            this.saveLoading = false;
						return;
					}
				}
				if(this.knowledgeList.other){
					if(this.knowledgeList.otherInput==""||this.knowledgeList.otherInput==null){
						this.$message({
							message: this.$t('msg_222'),
							type: 'error'
						});
            this.saveLoading = false;
						return;
					}
				}
				if (this.knowledgeList.faultPhenomenon == this.$t('label_380')) {
					this.knowledgeList.faultPhenomenon = this.knowledgeList.fault;
				}
				this.knowledgeList.precautionKey = "";
				this.knowledgeList.precautionVal = "";
				this.knowledgeList.impactKey = "";
				this.knowledgeList.impactVal = "";
				this.knowledgeList.impact = this.knowledgeList.checkList3[0];
				for(var key in this.knowledgeList.checkList1) {
					if (this.knowledgeList.checkList1[key] != '0') {
						if (this.knowledgeList.checkList1[key] == '2' && key == '0') {
							this.knowledgeList.impactKey += this.checkList2[1].key + ",";
							this.knowledgeList.impactVal += this.checkList2[1].val + ",";
						} else {
							if (this.knowledgeList.checkList1[key] == '2') {
								this.knowledgeList.impactKey += this.checkList2[1].key + ",";
								this.knowledgeList.impactVal += this.checkList2[1].val + ",";
							} else {
								this.knowledgeList.impactKey += this.checkList2[0].key + ",";
								this.knowledgeList.impactVal += this.checkList2[0].val + ",";
							}
						}
					}
				}
				if (this.knowledgeList.other) {
					this.knowledgeList.impactKey += "0";
					this.knowledgeList.impactVal += this.knowledgeList.otherInput;
				} else {
					this.knowledgeList.impactKey = this.knowledgeList.impactKey.substring(0,this.knowledgeList.impactKey.length - 1);
					this.knowledgeList.impactVal = this.knowledgeList.impactVal.substring(0,this.knowledgeList.impactVal.length - 1);
					this.knowledgeList.otherInput = "";
				}
				for(var key in this.knowledgeList.checkList2) {
					if (this.knowledgeList.checkList2[key] != '0') {
						if (this.knowledgeList.checkList2[key] == '2' && key == '0') {
							this.knowledgeList.precautionKey += this.checkList3[1].key + ",";
							this.knowledgeList.precautionVal += this.checkList3[1].val + ",";
						} else {
							if (this.knowledgeList.checkList2[key] == '2') {
								this.knowledgeList.precautionKey += this.checkList3[1].key + ",";
								this.knowledgeList.precautionVal += this.checkList3[1].val + ",";
							} else {
								this.knowledgeList.precautionKey += this.checkList3[0].key + ",";
								this.knowledgeList.precautionVal += this.checkList3[0].val + ",";
							}
						}
					}
				}
				if (this.knowledgeList.other1) {
					this.knowledgeList.precautionKey += "0";
					this.knowledgeList.precautionVal += this.knowledgeList.otherInput1;
				} else {
					this.knowledgeList.precautionKey = this.knowledgeList.precautionKey.substring(0,this.knowledgeList.precautionKey.length - 1);
					this.knowledgeList.precautionVal = this.knowledgeList.precautionVal.substring(0,this.knowledgeList.precautionVal.length - 1);
					this.knowledgeList.otherInput1 = "";
				}
				knowledge.update(this.knowledgeList).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.unUpdateVisible = false;

            this.$refs.theTreeKnow.reload();
						this.search({
							pageNum: this.pageNum,
							pageSize: this.pageSize,
						});
					}
          this.saveLoading = false;
				}).catch((response) => {
					console.log(response)
          this.saveLoading = false;
				})
			},
			unDeleteSend() {
				knowledge.del(this.tableInfo.id).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.unDeleteVisible = false;

            this.$refs.theTreeKnow.reload();
						this.search({
							pageNum: this.pageNum,
							pageSize: this.pageSize,
						});
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			look() {
				if (this.tableInfo != undefined && Object.keys(this.tableInfo).length > 0) {
					this.unLookVisible = true;
					// this.knowledgeList.id = this.tableInfo.id;
					// this.knowledgeList.equipmentTypeId = this.tableInfo.equipmentTypeId;
					// this.knowledgeList.typeName = this.tableInfo.typeName;
					// this.knowledgeList.faultPhenomenon = this.tableInfo.faultPhenomenon;
					// let flag = true;
					// for(var key in this.faultPhenomenonList) {
					// 	if (this.faultPhenomenonList[key].val == this.knowledgeList.faultPhenomenon) {
					// 		flag = false;
					// 		break;
					// 	}
					// }
					// if (flag) {
					// 	this.knowledgeList.fault = this.knowledgeList.faultPhenomenon;
					// 	this.knowledgeList.faultPhenomenon = this.$t('label_380');
					// }
					// this.knowledgeList.faultExplain = this.tableInfo.faultExplain;
					// this.knowledgeList.faultReasonClassify = this.tableInfo.faultReasonClassify;
					// this.getNameList2(this.knowledgeList.faultReasonClassify);
					// this.knowledgeList.faultReason = this.tableInfo.faultReason;
					// this.knowledgeList.checkList3 = [];
					// this.knowledgeList.checkList3.push(this.tableInfo.impact.toString());
					// this.knowledgeList.impact = this.knowledgeList.checkList3[0];
					// this.knowledgeList.solution = this.tableInfo.solution;
					// this.knowledgeList.precaution = this.tableInfo.precaution;
					// this.knowledgeList.checkList1 = this.tableInfo.impactKey.split(",");
					// this.knowledgeList.frequency = this.tableInfo.frequency;
					// let impactVal = this.tableInfo.impactVal.split(",");
					// for(var key in this.knowledgeList.checkList1) {
					// 	if (this.knowledgeList.checkList1[key] == 0) {
					// 		this.knowledgeList.other = true;
					// 		this.knowledgeList.otherInput = impactVal[impactVal.length - 1];
					// 	}
					// }
					// let precautionVal = this.tableInfo.precautionVal.split(",");
					// this.knowledgeList.checkList2 = this.tableInfo.precautionKey.split(",");
					// for(var key in this.knowledgeList.checkList2) {
					// 	if (this.knowledgeList.checkList2[key] == 0) {
					// 		this.knowledgeList.other1 = true;
					// 		this.knowledgeList.otherInput1 = precautionVal[precautionVal.length - 1];
					// 	}
					// }
					// this.knowledgeList.impactKey = this.tableInfo.impactKey;
					// this.knowledgeList.impactVal = this.tableInfo.impactVal;
					// this.knowledgeList.precautionKey = this.tableInfo.precautionKey;
					// this.knowledgeList.precautionVal = this.tableInfo.precautionVal;
					this.knowledgeList.id = this.tableInfo.id;
					this.knowledgeList.equipmentTypeId = this.tableInfo.equipmentTypeId;
					this.knowledgeList.typeName = this.tableInfo.typeName;
					this.knowledgeList.faultPhenomenon = this.tableInfo.faultPhenomenon;
					let flag = true;
					for(var key in this.faultPhenomenonList) {
						if (this.faultPhenomenonList[key].val == this.knowledgeList.faultPhenomenon) {
							flag = false;
							break;
						}
					}
					if (flag) {
						this.knowledgeList.fault = this.knowledgeList.faultPhenomenon;
						this.knowledgeList.faultPhenomenon = this.$t('label_380');
					}
					this.knowledgeList.faultExplain = this.tableInfo.faultExplain;
					// this.knowledgeList.faultReasonClassify = this.tableInfo.faultReasonClassify;
					// this.getNameList2(this.knowledgeList.faultReasonClassify);
					// this.knowledgeList.faultReason = this.tableInfo.faultReason;
					this.knowledgeList.faultReasonClassify = this.tableInfo.faultReasonClassify;
					this.getNameListEdit2(this.knowledgeList.faultReasonClassify);
					this.knowledgeList.faultReason = this.tableInfo.faultReason;
					if (this.tableInfo.impact != null) {
						this.knowledgeList.checkList3 = [];
						this.knowledgeList.checkList3.push(this.tableInfo.impact.toString());
					}
					this.knowledgeList.impact = this.knowledgeList.checkList3[0];
					this.knowledgeList.solution = this.tableInfo.solution;
					this.knowledgeList.precaution = this.tableInfo.precaution;
					if (this.tableInfo.impactKey != null) {
						this.knowledgeList.checkList1 = this.tableInfo.impactKey.split(",");
					}
					this.knowledgeList.frequency = this.tableInfo.frequency;
					let impactVal = "";
					if (this.tableInfo.impactVal != null) {
						impactVal = this.tableInfo.impactVal.split(",");
					}
					for(var key in this.knowledgeList.checkList1) {
						if (this.knowledgeList.checkList1[key] == 0) {
							this.knowledgeList.other = true;
							this.knowledgeList.otherInput = impactVal[impactVal.length - 1];
						}
					}
					if (this.tableInfo.precautionVal != null) {
						let precautionVal = this.tableInfo.precautionVal.split(",");
						this.knowledgeList.checkList2 = this.tableInfo.precautionKey.split(",");
						for(var key in this.knowledgeList.checkList2) {
							if (this.knowledgeList.checkList2[key] == 0) {
								this.knowledgeList.other1 = true;
								this.knowledgeList.otherInput1 = precautionVal[precautionVal.length - 1];
							}
						}
					}
					this.knowledgeList.impactKey = this.tableInfo.impactKey;
					this.knowledgeList.impactVal = this.tableInfo.impactVal;
					this.knowledgeList.precautionKey = this.tableInfo.precautionKey;
					this.knowledgeList.precautionVal = this.tableInfo.precautionVal;
					if (this.knowledgeList.checkList3[0] == '1') {
						this.knowledgeList.checkList1 = [];
						this.knowledgeList.other = "";
						this.knowledgeList.otherInput = "";
					}
				} else {
						utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
				}
			},
			setMealSelect() {
				// 截取数组的最后一位,并从新赋值
				this.knowledgeList.checkList3 = this.knowledgeList.checkList3.slice(-1)
				if (this.knowledgeList.checkList3[0] == '1') {
					this.knowledgeList.checkList1 = [];
					this.knowledgeList.other = "";
					this.knowledgeList.otherInput = "";
				}
			},
			querySearchAsync(queryString, cb) {
				let param = {
					name: this.knowledgeList.typeName
				}
				file.selectTypeListByName(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						cb(data.data)
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			handleSelect4(item) {
				this.knowledgeList.typeName = item.name
				this.knowledgeList.equipmentTypeId = item.id
			},
			showBtn() {
				this.qrCodeShow = !this.qrCodeShow;
				if (this.qrCodeShow) {
					this.width = "0px";
				} else {
					this.width = "340px";
				}
			},
      exportExcel() {
        let fault = ""
        if (this.faultPhenomenon == this.$t('label_380')) {
          fault = this.fault
        } else {
          fault = this.faultPhenomenon
        }
        let dataParam = {
          faultPhenomenon: fault,
          type: this.type,
          id: this.id,
          equipmentTypeId: this.equipmentTypeId,
          faultReason: this.faultReason,
          faultReasonClassify: this.faultReasonClassify
        }
        knowledge.exportExcel(dataParam).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          let link = document.createElement('a')
          link.href = url
          link.download = decodeURIComponent(response.headers['content-disposition'].split('fileName=')[1])
          link.click()
          URL.revokeObjectURL(url)
        })
      }
		},
		created() {
			this.getDictList1();
			// this.getDictList2();
			this.getDictList3();
			this.getDictList4();
			this.getDictList5();
			this.MenuRoleList = this.$store.getters.getMenu;
		}
	}
</script>
<style scoped>
 .btnBox2 {
     display: -webkit-box;
     display: -ms-flexbox;
     display: flex;
     -webkit-box-pack: start;
     -ms-flex-pack: start;
     justify-content: flex-start;
     margin-left: -1px;
 }
</style>
<style>
	.cb .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
		border-color: #ffffff;
	}
	.cb .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
		background-color: #409EFF;
		border-color: #409EFF;
	}
	.right-showbtn-qrcode-background {
		/* position: absolute; */
		width: 10px;
		height: 80px;
		background-color: #9c9c9c;
		border-top-right-radius: 10px;
		border-bottom-right-radius: 10px;
		margin: auto;
	}
	.right-showbtn {
		width: 10px;
		height: 100%;
		display: flex;
		position: relative;
		z-index: 100000;
	}
</style>



// WEBPACK FOOTER //
// src/pages/malfunction/malfunctionKnowledgePage.vue